import React, { FC, ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DropdownWithLabel } from '@blueprint/dropdown';
import { MultiColumnDropdownWithLabel } from '@blueprint/multicolumn-dropdown';
import {
    ForSalePriceMinSelectOptions,
    ForSalePriceMaxSelectOptions
} from '../../../search/common/SelectPriceOptions';
import {
    updateFilter,
    minPriceSelector,
    maxPriceSelector
} from '../../../reducers/filters';
import { DropdownContainer } from '../../../search/common/DropdownContainer';
import { buildSelectPriceTitleForSale } from '../../../search/helpers';

export const SelectPriceForSale: FC = () => {
    const reduxDispatch = useDispatch();
    const {
        selectedValue: priceMinSelectedValue,
        options: priceMinOptions
    } = useSelector(minPriceSelector);

    const {
        selectedValue: priceMaxSelectedValue,
        options: priceMaxOptions
    } = useSelector(maxPriceSelector);

    const onMaxPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('maxPrice', evt.currentTarget.value));
    };

    const onMinPriceChange = (evt: ChangeEvent<HTMLSelectElement>) => {
        reduxDispatch(updateFilter('minPrice', evt.currentTarget.value));
    };

    const buttonText = buildSelectPriceTitleForSale(
        priceMinSelectedValue,
        priceMaxSelectedValue
    );

    const priceMinInt = parseInt(priceMinSelectedValue || '0', 10);
    const priceMaxInt = parseInt(priceMaxSelectedValue || '0', 10);

    const PriceOptionLabel = 'Any price';

    return (
        <MultiColumnDropdownWithLabel
            title={buttonText}
            label="Price range"
            testId="AnyPrice_testId"
            isLeft
        >
            <DropdownContainer>
                <DropdownWithLabel
                    id="price_min"
                    onChange={onMinPriceChange}
                    value={priceMinSelectedValue}
                    name="price_min"
                    hasBorderRadius
                    aria-label="Min Price"
                    data-testid="min_price_testid"
                    label="Minimum price"
                >
                    {priceMinOptions ? (
                        <ForSalePriceMinSelectOptions
                            options={priceMinOptions}
                            priceOtherInt={priceMaxInt}
                            keyPrefix="pricemin"
                        />
                    ) : (
                        <option>{PriceOptionLabel}</option>
                    )}
                </DropdownWithLabel>
            </DropdownContainer>
            <DropdownContainer>
                <DropdownWithLabel
                    id="price_max"
                    onChange={onMaxPriceChange}
                    value={priceMaxSelectedValue}
                    name="price_max"
                    hasBorderRadius
                    aria-label="Max Price"
                    data-testid="max_price_testid"
                    label="Maximum price"
                >
                    {priceMaxOptions ? (
                        <ForSalePriceMaxSelectOptions
                            options={priceMaxOptions}
                            priceOtherInt={priceMinInt}
                            keyPrefix="pricemax"
                        />
                    ) : (
                        <option>{PriceOptionLabel}</option>
                    )}
                </DropdownWithLabel>
            </DropdownContainer>
        </MultiColumnDropdownWithLabel>
    );
};
